import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Modal from '../common/Modal/Modal';
import StudySelector from '../common/StudySelector';
import GenericButton from '../common/GenericButton';
import * as crosstabActions from '../../actions/crosstabActions';
import * as quickReportsActions from '../../actions/quickReportsActions';
import * as studyActions from '../../actions/studyActions';
import { QUICKREPORT_EXPORT_REPORT, FLEX_STUDY_TAG } from '../../constants';
import { exportFileTitle } from '../../util/CommonUtils';

import { REPORT_TYPES, DYNAMIC_REPORT_TYPES } from '../../util/QuickReportsUtils';

const modalStyle = {
  width: 'auto',
  minWidth: '770px',
  maxWidth: '800px',
  height: 'auto',
  top: '5%',
  left: '24%',
};

const afterModuleChangeModalStyle = {
  width: '20%',
  height: 'auto',
  left: '35%',
  top: '20%',
};

class QuickReportToolPalate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      quickReportsStudy: props.quickReportsStudy,
      isViewScreenSelected: false,
      selectedExportOption: '',
    };
  }

  componentDidMount() {
    if (this.state.quickReportsStudy &&
      this.state.quickReportsStudy.st.toLowerCase().includes(FLEX_STUDY_TAG)) {
      this.afterModuleChangeModal.show();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.quickReportsStudy !== nextProps.quickReportsStudy) {
      this.setState({ quickReportsStudy: nextProps.quickReportsStudy });
    }
  }

  logChange = val => {
    if (val.value === 'More') {
      this.studyModal.show();
    } else {
      this.props.studyActions.updateModuleStudy('quickReports', {
        ...val,
        wt: 1,
      });
      this.validateClearReport(val);
    }
  };

  validateClearReport = ({ studyDescription }) => {
    if (
      this.props.quickReports &&
      this.props.quickReports.selectedReport &&
      !this.props.quickReports.selectedReport.isForAllStudy &&
      !/simmons\sconnect/gi.test(studyDescription)
    ) {
      this.props.quickReportsActions.clearReport();
    }
  };

  handleExportQuickReport = type => {
    this.props.trackerFn({ action: QUICKREPORT_EXPORT_REPORT });
    // { token, uid, accountId, reportName, productNo, weightType, customWeights,
    //   targetLabel, targetExpression, baseLabel, baseExpression, subType, combos
    // }
    const token = this.props.loginResponse.data.token;
    const uid = this.props.loginResponse.data.uid;
    const accountId = this.props.activeAccountId;
    const productNo = this.props.quickReportsStudy.pn;
    const reportName = this.props.quickReports.reportResult
      ? this.props.quickReports.reportResult.reportName
      : undefined;
    const weightType = this.props.quickreportsWeightTypes.wt;
    const divisor = this.props.quickreportsWeightTypes.dv;
    const selectedWeightName = this.props.quickreportsWeightTypes.wn;
    const targetLabel =
      this.props.quickReports.TargetDataGridData &&
      this.props.quickReports.TargetDataGridData[0]
        ? this.props.quickReports.TargetDataGridData[0].title
        : undefined;
    const targetExpression =
      this.props.quickReports.TargetDataGridData &&
      this.props.quickReports.TargetDataGridData[0]
        ? this.props.quickReports.TargetDataGridData[0].keyword
        : undefined;
    const baseLabel =
      this.props.quickReports.BaseDataGridData &&
      this.props.quickReports.BaseDataGridData[0]
        ? this.props.quickReports.BaseDataGridData[0].title
        : undefined;
    const baseExpression =
      this.props.quickReports.BaseDataGridData &&
      this.props.quickReports.BaseDataGridData[0]
        ? this.props.quickReports.BaseDataGridData[0].keyword
        : undefined;
    const option = this.props.quickReports.exportParams
      ? this.props.quickReports.exportParams.option
      : undefined;
    const categoryCount =
      this.props.quickReports.exportParams &&
      this.props.quickReports.exportParams.categoryCount
        ? parseInt(this.props.quickReports.exportParams.categoryCount, 10)
        : undefined;
    const subType = this.props.quickReports.exportParams
      ? this.props.quickReports.exportParams.subType
      : undefined;
    const combos = this.props.quickReports.exportParams
      ? this.props.quickReports.exportParams.combos
      : undefined;
    const incrementalReach = this.props.quickReports.exportParams
      ? this.props.quickReports.exportParams.incrementalReach
      : undefined;
    const remove = this.props.quickReports.exportParams
      ? this.props.quickReports.exportParams.remove
      : undefined;
    let reportsName = ''; 
    REPORT_TYPES.forEach(report => {
      const finalReportName = report.key === reportName ? reportName : DYNAMIC_REPORT_TYPES[reportName];
      if(report.key === finalReportName) {
        if(finalReportName === 'SEGMENTATION') {
          reportsName = `${this.getSubReportDropdown(subType)}_${report.exportFileTitle}`;
        } else if(finalReportName === 'REACH') {
          reportsName = `${report.exportFileTitle}_by_${option}_${this.getSubReportDropdown(subType)}`;
        } else if(finalReportName === 'MAAP') {
          reportsName = `${report.exportFileTitle}_${this.getSubReportDropdown(subType)}`;
        }  else if(finalReportName === 'MPAA') {
          reportsName = `${report.exportFileTitle}_${this.getSubReportDropdown(subType)}`;
        } else if(finalReportName === 'DIL_S_ALL') {
          if(reportName.indexOf("DIL_S") !== -1) {
            reportsName = `Smartphone_${report.exportFileTitle}`;
          } else {
            reportsName = `Mobile_${report.exportFileTitle}`;
          }
        } else if(finalReportName === 'CCAT_7') {
          if(reportName === "CCAT_30" || reportName === "CCAT_30D") {
            reportsName = `${report.exportFileTitle}_by_${option}_Last_30_Days`;
          } else {
            reportsName = `${report.exportFileTitle}_by_${option}_Last_7_Days`;
          }
        } else if(finalReportName === 'WEBR_7') {
          if(reportName === "WEBR_30" || reportName === "WEBR_30D") {
            reportsName = `${report.exportFileTitle}_Last_30_Days`;
          } else {
            reportsName = `${report.exportFileTitle}_Last_7_Days`;
          }
        } else {
          reportsName = report.exportFileTitle;
        }
      }
    });
    const fileName = reportName === undefined ? exportFileTitle('QR') : exportFileTitle(`QR_${reportsName}`);
    const exportParams = {
      token,
      uid,
      accountId,
      reportName,
      productNo,
      weightType,
      divisor,
      selectedWeightName,
      targetLabel,
      targetExpression,
      baseLabel,
      baseExpression,
      option,
      subType,
      combos,
      incrementalReach,
      categoryCount,
      remove,
      fileName,
    };
    if (type === 'excel' && reportName && targetLabel) {
      this.props.quickReportsActions.exportQuickReports(exportParams);
    }
  };

  getSubReportDropdown = (subType) => {
    const subReportDropdown = this.props.quickReports && this.props.quickReports.reportResult ? 
    this.props.quickReports.reportResult.subReportDropdown : [];
    const report = subReportDropdown.filter(subReports => subReports.key === subType);
    if(report !== undefined && report.length > 0) {
      return report[0].value;
    }
    
    return '';
  }

  render() {
    return (
      <div className="width-20 minimize-tp float-left">
        <ul className="accordion tool_bg">
          {// hiding Export for QR Maps based on PLAT-10735
          }
          {(this.props.selectedReport && this.props.selectedReport.key !== 'MAP') && <li
            className={`accordion__item${
              this.props.dataScreen ? ' dataHaul-disabled' : ''
            }`}
          >
            <input
              type="checkbox"
              className="accordion__toggle"
              id="toggle-07"
            />
            <label
              className="accordion__trigger quick_report tool_img export_tool_qr"
              htmlFor="toggle-07"
              title="Export"
            >
              Export
            </label>
            <div className="accordion__target padding-rl20">
              <div className="chart-type">
                <p
                  className="export_xls"
                  title="EXPORT .XLS"
                  onClick={() => this.handleExportQuickReport('excel')}
                >
                  export .xls
                </p>
              </div>
              {/* {<div className="chart-type">
                <p className="export" title=".SPC" onClick={() => this.handleExportSPC()} />
              </div>
              <div className="chart-type">
                <p className="export_spc" title=".CSV" onClick={() =>
                  this.handleExportCrosstab('csv')} />
              </div>} */}
            </div>
          </li>}
          {/* <li className={`accordion__item${this.props.dataScreen ? ' dataHaul-disabled' : ''}`}>
            <input type="checkbox" className="accordion__toggle" id="toggle-06" />
            <label className="accordion__trigger quick_report tool_img print_tool_qr"
            htmlFor="toggle-06" title="Print">
              Print
            </label>
          </li> */}
        </ul>
        <Modal
          title="Select Current Study"
          ref={node => (this.studyModal = node)}
          dialogStyles={modalStyle}
        >
          <StudySelector
            handleParentHide={selectedStudy => {
              this.studyModal.hide();
              this.validateClearReport(selectedStudy);
            }}
            selectedStudy={this.state.quickReportsStudy}
            selectedModule="quickReports"
          />
        </Modal>
        <Modal
          title="Change Study"
          ref={node => (this.afterModuleChangeModal = node)}
          dialogStyles={afterModuleChangeModalStyle}
        >
          <p>
            You have selected a flexible market study. This study data is only
            available in Crosstab.
          </p>
          <GenericButton
            name="OK"
            btnStyle="button display-block margin-auto"
            onBtnClick={() => this.afterModuleChangeModal.hide()}
          />
        </Modal>
      </div>
    );
  }
}

QuickReportToolPalate.propTypes = {
  quickReportsStudy: PropTypes.shape({
    pn: PropTypes.number,
    wt: PropTypes.number,
  }),
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      uid: PropTypes.number,
      token: PropTypes.string,
    }),
  }),
  studyActions: PropTypes.shape({
    updateModuleStudy: PropTypes.func,
  }),
  quickReportsActions: PropTypes.shape({
    exportQuickReports: PropTypes.func,
    clearReport: PropTypes.func,
  }),
  quickReports: PropTypes.shape({
    reportResult: PropTypes.shape({
      reportName: PropTypes.string,
      subReportDropdown: PropTypes.shape({}),
    }),
    selectedReport: PropTypes.shape({
      isForAllStudy: PropTypes.bool,
    }),
    exportParams: PropTypes.shape({
      option: PropTypes.string,
      subType: PropTypes.string,
      combos: PropTypes.arrayOf(PropTypes.arrayOf),
      incrementalReach: PropTypes.arrayOf(),
      categoryCount: PropTypes.number,
      remove: PropTypes.arrayOf(),
    }),
    TargetDataGridData: PropTypes.arrayOf(PropTypes.object),
    BaseDataGridData: PropTypes.arrayOf(PropTypes.object),
  }),
  activeAccountId: PropTypes.number,
  dataScreen: PropTypes.string,
  trackerFn: PropTypes.func,
  quickreportsWeightTypes: PropTypes.shape({
    wt: PropTypes.number,
    dv: PropTypes.number,
    wn: PropTypes.string,
  }),
  selectedReport: PropTypes.instanceOf(Object),
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    quickReportsStudy: state.study.quickReportsStudy,
    activeAccountId: state.account.activeAccountId,
    quickReports: state.quickReports,
    quickreportsWeightTypes: state.study.quickreportsWeightTypes,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    crosstabActions: bindActionCreators(crosstabActions, dispatch),
    quickReportsActions: bindActionCreators(quickReportsActions, dispatch),
    studyActions: bindActionCreators(studyActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(QuickReportToolPalate);
